import '../styles/PageGlobal.css';
import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { TVAStateService } from '../services/TVAStateService.js';

export default function TVAStateEditPage() {
  const { state_id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({ code: '', label: '' });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchState = useCallback(async () => {
    const service = new TVAStateService();
    setLoading(true);
    try {
      const data = await service.getTVAStateById(state_id);
      setForm({
       
        label: data.label || ''
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [state_id]);

  useEffect(() => { fetchState(); }, [fetchState]);

  const handleChange = (e) => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSave = async () => {
    if (!form.label) {
      setError("Le code et le label sont requis.");
      return;
    }
    const service = new TVAStateService();
    setLoading(true);
    try {
      const payload = { id: parseInt(state_id, 10), ...form };
      await service.updateTVAState(state_id, payload);
      alert("État TVA modifié avec succès !");
      navigate("/tva-state-list");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div>Chargement…</div>;
  if (error) return <div className="tva-error">{error}</div>;

  return (
    <div className="containerMain tva-edit-container">
      <h1 className="tva-edit-title">Modifier l'État / Pays TVA</h1>
      {error && <div className="tva-error">{error}</div>}

      <div className="tva-edit-form" style={{ maxWidth: '500px' }}>
        
        <div className="tva-edit-row">
          <label>Label / Pays *</label>
          <input type="text" name="label" value={form.label} onChange={handleChange} required />
        </div>
      </div>

      <div className="tva-edit-footer">
        <button className="tva-btn tva-btn-blue" onClick={handleSave} disabled={loading}>{loading ? '...' : 'Enregistrer'}</button>
        <button className="tva-btn tva-btn-grey" onClick={() => navigate("/tva-state-list")} disabled={loading}>Annuler</button>
      </div>
    </div>
  );
}